module.exports = __webpack_public_path__ + "img/yc-step-1-label.svg";